import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-card-two-booking-steps-two',
  templateUrl: './card-two-booking-steps-two.component.html',
  styleUrls: ['./card-two-booking-steps-two.component.scss']
})
export class CardTwoBookingStepsTwoComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

}
